
define('text!templates/components/lead_note/lead_notes.html',[],function () { return '<div class="list-container">\n\n</div>\n';});

